// extracted by mini-css-extract-plugin
export default {"popup":"ScheduleTypeSelector_popup__fBs3L","square":"ScheduleTypeSelector_square__DqMAc"};